export default function getSelectedText(editor) {
  return editor.value.fragment.getBlocks().map(function (block) {
    return block.text;
  }).join('\n');
}